import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { GlobalTranslateService } from '@app/services/globalTranslate/globalTranslate.service';
import { ServiceConfigService } from '@app/services/service-config.service';
import { TranslateService } from '@ngx-translate/core';
import { from } from 'rxjs';

// Regex patterns that match with or without braces (translation may strip braces)
const INDIV_REGEX = /\{?x1x\}?/g;
const TYP_REGEX = /\{?x2x\}?/g;
const BOLD_START_REGEX = /\{?x3x\}?/g;
const BOLD_END_REGEX = /\{?x4x\}?/g;

@Pipe({
  name: 'restoreindiv',
  pure: false,
  standalone: false
})
export class RestoreindivPipe implements PipeTransform {
  defaultLanguage;
  awsTranslateSwitch = false;
  private cachedTypValue: string = '';
  private lastSecondTxtValue: string = '';
  private isTranslating = false;

  constructor(public translateService: TranslateService, public globalTranslationService: GlobalTranslateService, private serverConfig: ServiceConfigService, public cdr: ChangeDetectorRef) { }

  transform(text: string, txtToReplace: string, secondTxt: any = null): string {
    if (!text) {
      return text || '';
    }

    let resultText = text;
    this.defaultLanguage = this.translateService.getDefaultLang();

    // Replace INDIV_PLACEHOLDER with actual name
    if (txtToReplace) {
      const name = txtToReplace.split(',');
      const actualName = name[0] || '';
      resultText = resultText.replace(INDIV_REGEX, actualName);
    }

    // Replace TYP_PLACEHOLDER with actual value
    if (secondTxt) {
      let typValue;
      let selectedLang = sessionStorage.getItem('globalTranslatedLan') && sessionStorage.getItem('globalTranslatedLan') !== 'undefined' ? sessionStorage.getItem('globalTranslatedLan') : null;
      this.awsTranslateSwitch = this.serverConfig.getServerConfig().awsTranslateSwitch;

      if (!this.awsTranslateSwitch) {
        typValue = this.defaultLanguage === 'en' ? secondTxt['value'] : secondTxt['spValue'];
        resultText = resultText.replace(TYP_REGEX, (typValue || '') + ' ');
      } else {

        //if secondTxt needs Translation
        if ((this.defaultLanguage === 'en' && selectedLang)) {
          const currentValue = secondTxt['value'];

          // If we have a cached translation for this value, use it
          if (this.lastSecondTxtValue === currentValue && this.cachedTypValue) {
            resultText = resultText.replace(TYP_REGEX, (this.cachedTypValue || '') + ' ');
          } else if (!this.isTranslating || this.lastSecondTxtValue !== currentValue) {
            // Start translation if not already translating this value
            this.isTranslating = true;
            this.lastSecondTxtValue = currentValue;
            resultText = resultText.replace(TYP_REGEX, (currentValue || '') + ' ');

            from(this.globalTranslationService.translate(currentValue, selectedLang)).subscribe(awsTranslated => {
              this.cachedTypValue = awsTranslated;
              this.isTranslating = false;
              this.cdr.markForCheck();
            });
          } else {
            // Still translating, show English for now
            resultText = resultText.replace(TYP_REGEX, (currentValue || '') + ' ');
          }
        // no translation needed for secondTxt
        } else {
          typValue = this.defaultLanguage === 'en' ? secondTxt['value'] : secondTxt['spValue'];
          resultText = resultText.replace(TYP_REGEX, (typValue || '') + ' ');
        }

      }
    } else {
      resultText = resultText.replace(TYP_REGEX, ' ');
    }

    // Replace bold placeholders with actual <b> tags
    resultText = resultText.replace(BOLD_START_REGEX, '<b>');
    resultText = resultText.replace(BOLD_END_REGEX, '</b>');
    return resultText;
  }
}
